<!-- 分成方对账申请页 -->
<template>
  <scroll-layout class="details">
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <template v-for="(button, index) in pageButtons">
          <ykc-button
            :key="index"
            v-if="button.enabled"
            v-bind="button"
            @click="button.handleClick(button, $event)">
            {{ button.text }}
          </ykc-button>
        </template>
      </div>
    </template>
    <div class="content">
      <ykc-detail-plus class="box-card" :labelWidth="120">
        <div slot="header" class="clearfix" style="height: auto">
          <div class="btn-wrap">
            <el-button
              size="small"
              class="confirm"
              :loading="loading"
              type="primary"
              @click="submit">
              提交申请
            </el-button>
          </div>

          <span>基本信息</span>
        </div>
        <div class="flexBox">
          <ykc-form
            ref="ruleForm"
            class="YkcForms"
            :model="ruleForm"
            :rules="rules"
            labelPosition="right">
            <ykc-form-item
              label="结算时间"
              prop="settleDate"
              style="width: 380px; margin-bottom: 0">
              <el-date-picker
                v-model="ruleForm.settleDate"
                type="monthrange"
                range-separator="至"
                @change="timeChange"
                start-placeholder="结算开始月份"
                end-placeholder="结算结束月份"
                :picker-options="pickerOptions"
                format="yyyy-MM"
                value-format="yyyy-MM"></el-date-picker>
            </ykc-form-item>
            <span class="settle-date-tip">
              注：当前已提交的结算周期前存在未结算时段时，请提交当前可结算时段后再行申请
            </span>
          </ykc-form>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="站点编码">
            <span>{{ dealData(formData.stationCode) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="站点名称">
            <span>{{ dealData(formData.stationName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="结算方类型">
            <span>{{ dealData(formData.partnerTypeName) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="结算方名称">
            <span>{{ dealData(formData.partnerName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="服务费抽成配置">
            <span>{{ dealData(serviceFeeConfig) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="服务费分成金额">
            <span>{{ dealData(formData.serviceFeeSharingAmount) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="结算总金额">
            <span>{{ dealData(formData.settleTotalAmount) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="申请备注">
            <ykc-input
              v-model="ruleForm.remark"
              type="textarea"
              placeholder="备注"
              maxlength="500"></ykc-input>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label=""></ykc-detail-item-plus>
        </div>
        <ykc-table
          ref="YkcTable"
          style="box-shadow: none"
          operateFixedType="right"
          :data="tableData"
          title="结算清单按月信息"
          :columns="tableColumns"
          :operateButtons="tableOperateButtons"></ykc-table>
      </ykc-detail-plus>
    </div>
  </scroll-layout>
</template>

<script>
  import dayjs from 'dayjs';
  import { partnerSettleManage } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'PartnerSettleApply',
    components: {},
    data() {
      return {
        stationId: '',
        partnerId: '',
        formData: {},
        disabledStartTime: '',
        disabledEndTime: '',
        loading: false,
        ruleForm: {
          remark: '',
          startTime: '',
          endTime: '',
          settleDate: [],
        },
        isFirst: true,
        rules: {
          settleDate: [
            { type: 'array', required: true, message: '请选择结算日期', trigger: 'blur' },
          ],
        },
        tableData: [],
        tableColumns: [
          {
            label: '年月',
            prop: 'date',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                return dayjs(row.date).format('YYYY-MM');
              },
            },
          },
          { label: '服务费分成', prop: 'serviceFeeSharingAmount', minWidth: '120px' },
          { label: '总金额', prop: 'totalAmount', minWidth: '100px' },
        ],
        tableOperateButtons: [
          {
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.exportDetail(row);
                }}>
                导出明细
              </ykc-button>
            ),
          },
        ],
      };
    },
    computed: {
      serviceFeeConfig() {
        if (this.formData.serviceWayName && this.formData.serviceFeeSharing) {
          return `${this.formData.serviceWayName} ${this.formData.serviceFeeSharing}${
            this.formData.serviceWaySuffix || ''
          }`;
        }
        return '';
      },
      pageButtons() {
        return [
          {
            text: '返回',
            type: 'plain',
            enabled: true,
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ];
      },
      pickerOptions() {
        const that = this;
        return {
          disabledDate(date) {
            // 后端未返回可结算结束时间时，默认最多只能选到上个月
            const effectiveEndTime =
              that.disabledEndTime || dayjs().subtract(1, 'month').format('YYYY-MM');
            if (that.disabledStartTime) {
              return (
                (date && date.valueOf() > dayjs(effectiveEndTime).valueOf()) ||
                date.valueOf() < dayjs(that.disabledStartTime).valueOf()
              );
            }
            return date && date.valueOf() > dayjs(effectiveEndTime).valueOf();
          },
        };
      },
    },
    created() {
      const { stationId, partnerId } = this.$route.query;
      this.stationId = stationId;
      this.partnerId = partnerId;
      this.queryDetail();
    },
    methods: {
      dealData(value) {
        return value === null || value === undefined || value === '' ? '——' : value;
      },
      queryDetail() {
        if (this.stationId && this.partnerId) {
          partnerSettleManage
            .getSettleInfo({
              stationId: this.stationId,
              partnerId: this.partnerId,
              startTime: this.ruleForm.startTime,
              endTime: this.ruleForm.endTime,
            })
            .then(res => {
              this.formData = res;
              const startTime = res.startTime ? dayjs(res.startTime).format('YYYY-MM') : '';
              const endTime = res.endTime ? dayjs(res.endTime).format('YYYY-MM') : '';
              this.ruleForm.startTime = res.startTime;
              this.ruleForm.endTime = res.endTime;
              if (startTime && endTime) {
                this.ruleForm.settleDate = [startTime, endTime];
              }
              if (this.isFirst) {
                this.disabledEndTime = endTime;
                this.disabledStartTime = startTime;
                this.isFirst = false;
              }
              this.tableData = res.settleDetail || [];
            })
            .catch(() => {});
        }
      },
      timeChange(value) {
        this.ruleForm.startTime = dayjs(value[0]).startOf('month').format('YYYY-MM-DD HH:mm:ss');
        this.ruleForm.endTime = dayjs(value[1]).endOf('month').format('YYYY-MM-DD HH:mm:ss');
        this.queryDetail();
      },
      exportDetail(row) {
        const { date } = row;
        const { stationId, partnerId } = this;
        const month = dayjs(date).format('YYYY-MM');
        offlineExport({
          downloadType: 'finance_export',
          jsonNode: {
            downloadKey: 'partnerExportMonthDetailList',
            stationId,
            partnerId,
            month,
          },
        });
      },
      submit() {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            this.loading = true;
            partnerSettleManage
              .addOne({
                endTime: this.ruleForm.endTime,
                stationId: this.stationId,
                partnerId: this.partnerId,
                remark: this.ruleForm.remark,
                startTime: this.ruleForm.startTime,
              })
              .then(res => {
                this.$message.success('申请成功！');
                // 返回列表页并带上刷新标记
                this.$router.replace({
                  path: '/propertyStatistics/partnerSettlement',
                  query: { refresh: Date.now() },
                });
              })
              .finally(() => {
                // 无论成功失败都要关闭 loading，避免接口报错后按钮一直转圈
                this.loading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    .box-card {
      width: 100%;
      height: auto;
      border-radius: 0;
      margin: 10px 0px 0px 0px;
      border: none;
      .btn-wrap {
        margin-bottom: 10px;
      }
      ::v-deep .el-card__header {
        border: 0;
        padding: 10px;
        height: auto;
        box-sizing: border-box;

        @media screen and (max-width: 1366px) {
          height: auto;
        }
      }
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .flexBox {
        display: flex;
        margin-bottom: 20px;
      }
      .YkcForms {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
        align-items: center;
        .settle-date-tip {
          margin-left: 16px;
          font-size: 12px;
          color: #9b9b9b;
        }
        ::v-deep .ykc-form-item {
          width: 50%;
          .el-form-item {
            display: flex;

            .el-form-item__label {
              line-height: 30px;
              padding: 0 8px 0 0;
              font-size: 12px;
              width: 74px;
            }

            .el-form-item__content {
              flex: 1;
            }
          }
        }
      }
    }
  }
</style>
